import {CouponCenterTransaction} from 'rest/types/CouponCenterTransaction'
import {PaginatedResult} from 'rest/types/PaginatedResult'
import {currencySignMap} from 'utils/currencySignMap'
import formatNumber from 'utils/formatNumber'

type Props = {
  results: PaginatedResult<CouponCenterTransaction>
}
export default function OrderHistoryTable({results}: Props) {
  if (results?.count === 0) {
    return null
  }

  return (
    <div className="max-w-4xl mt-10 p-6 bg-white rounded-2xl shadow-md border">
      <h2 className="text-2xl font-bold mb-6">Order History</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="text-gray-600 text-sm">
              <th className="py-2 px-4 border-b">Order ID</th>
              <th className="py-2 px-4 border-b">Date</th>
              <th className="py-2 px-4 border-b">Amount</th>
              <th className="py-2 px-4 border-b"></th>
            </tr>
          </thead>
          <tbody>
            {results.results.map(order => (
              <tr key={order.id} className="hover:bg-gray-50">
                <td className="py-3 px-4 border-b">#{order.id}</td>
                <td className="py-3 px-4 border-b">
                  {new Date(
                    order.transaction_created * 1000
                  ).toLocaleDateString('en-US')}
                </td>
                <td className="py-3 px-4 border-b">
                  {currencySignMap[order.currency.toLowerCase()]}
                  {formatNumber(order.amount / 100, {decimals: 2})}
                </td>
                <td className="py-3 px-4 border-b text-right relative">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={order.receipt_url}
                    className="block px-4 py-2 text-sm text-gray-700 underline hover:bg-gray-100">
                    View Receipt
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
